import { Component, OnDestroy, OnInit } from '@angular/core';
import { LicenseMessageDialogComponent } from '../license-message-dialog/license-message-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-license-blocker',
    templateUrl: './license-blocker.component.html'
})
export class LicenseBlockerComponent implements OnInit, OnDestroy {
    dialogRef: undefined | any;
    constructor(private readonly dialog: MatDialog) {}
    ngOnInit(): void {
        this.dialogRef = this.dialog.open(LicenseMessageDialogComponent, { disableClose: true, autoFocus: false });
    }

    ngOnDestroy(): void {
        this.dialogRef.close();
        this.dialogRef = undefined;
    }
}
